// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"c251ab94","176":"b7de8917","208":"ac8e5500","409":"36e31c2f","631":"5d8d9531","760":"34f6bf76","774":"d0830be5","787":"1bb3fefb"}[chunkId] + ".chunk.js";
};